import { render, staticRenderFns } from "./GrStatusBadge.vue?vue&type=template&id=b4a5df50&scoped=true"
import script from "./GrStatusBadge.vue?vue&type=script&lang=js"
export * from "./GrStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./GrStatusBadge.vue?vue&type=style&index=0&id=b4a5df50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5df50",
  null
  
)

export default component.exports